import {createContext} from "react";

export interface IFormContext {
    submitted: boolean
}

export class FormContextManager implements IFormContext {
    constructor(private state: IFormContext,
        private setState: (i: Partial<IFormContext>) => void) {
    }

    get submitted() {
        return this.state.submitted;
    }

    set submitted(i: boolean) {
        this.update({
            submitted: i
        });
    }

    private update = (i: Partial<IFormContext>) => {
        this.setState({
            ...this.state,
            ...i
        });
    }
}

export const FormContext = createContext<FormContextManager>(new FormContextManager({
    submitted: false
}, () => {}));


export function getFormContext(use_context: any) {
    return use_context(FormContext) as FormContextManager;
}
